import api from "../../config/client.axios.api";

export const updateSolutionApi = async (infoUpdate: any) => {
  const response = await api.put(`/solution`, infoUpdate);
  return response.data;
};
